import React from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
export function OwnerSubmittedPage() {
  return <>
      <SEO title="Submission Received — Aspect" description="Your property information has been received. We'll confirm scope and settings before scheduling photography." data-id="element-552" />
      <div className="max-w-2xl" data-id="element-553">
        <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-16 text-aspect-black" data-id="element-554">
          Submission received
        </h1>

        <div className="space-y-16" data-id="element-555">
          <section data-id="element-556">
            <p className="text-lg text-aspect-black/80 leading-relaxed" data-id="element-557">
              Your property information has been received.
            </p>
          </section>

          <section className="space-y-4" data-id="element-558">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-559">
              What happens next
            </h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-560">
              We'll confirm scope, access requirements, and visibility settings
              before any photography is scheduled.
            </p>
          </section>

          <section className="space-y-4" data-id="element-561">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-562">Timing</h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-563">
              Expect a response within one business day.
            </p>
          </section>

          <section className="space-y-4" data-id="element-564">
            <h2 className="text-xl font-medium text-aspect-black" data-id="element-565">Reference</h2>
            <p className="text-aspect-black/80 leading-relaxed" data-id="element-566">
              For details on privacy, approvals, and takedown controls, see the{' '}
              <Link to="/faq#owners" className="text-aspect-black underline hover:text-aspect-black/70" data-id="element-567">
                Owner FAQs
              </Link>
            </p>
          </section>
        </div>
      </div>
    </>;
}